/* @ngInject */

export default ($timeout) => {
  function validatePhone(ctrl, region, prefix, number, expectedResult) {
    try {
      var numberOnly = number.replace(/[^0-9]/g, '');
      if (numberOnly !== '') {
        var phoneNumber = '+' + prefix.replace(/[^0-9]/g, '') + numberOnly;
        var phoneUtilities = i18n.phonenumbers.PhoneNumberUtil.getInstance();
        var phoneObject = phoneUtilities.parseAndKeepRawInput(phoneNumber, region);
        var phoneType = phoneUtilities.getNumberType(phoneObject);
        var isPossible = phoneUtilities.isPossibleNumber(phoneObject);
        var isValid = phoneUtilities.isValidNumber(phoneObject);
        var isInRegion = region
          ? phoneUtilities.isValidNumberForRegion(phoneObject, region)
          : true;
        var isFixed = phoneType === 0;
        var isMobile = phoneType === 1;
        var isFixedOrMobile = phoneType === 2;
        var isPager = phoneType === 8;
        var isPersonal = phoneType === 7;
        var isPremium = phoneType === 4;
        var isShared = phoneType === 5;
        var isTollFree = phoneType === 3;
        var isUAN = phoneType === 9;
        var isVoiceMail = phoneType === 10;
        var isVoIP = phoneType === 6;
        ctrl.$setValidity('isUnknown', isPossible && isValid);
      } else {
        ctrl.$setValidity('isUnknown', false);
      }
    } catch (err) {
      ctrl.$setValidity('isUnknown', false);
    }
    ctrl.$setTouched();
    ctrl.$setDirty();
  }

  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      stPhoneRegion: '@',
      stPhonePrefix: '@',
      stPhoneExpectedType: '&'
    },
    link: function (scope, element, attrs, ctrl) {
      element.bind('keydown keypress', function ($event) {
        $timeout(function () {
          validatePhone(
            ctrl,
            attrs.stPhoneRegion,
            attrs.stPhonePrefix,
            ctrl.$modelValue,
            attrs.stPhoneExpectedType
          );
        });
      });
      attrs.$observe('stPhonePrefix', function (val) {
        $timeout(function () {
          validatePhone(
            ctrl,
            attrs.stPhoneRegion,
            attrs.stPhonePrefix,
            ctrl.$modelValue,
            attrs.stPhoneExpectedType
          );
        });
      });
      validatePhone(
        ctrl,
        attrs.stPhoneRegion,
        attrs.stPhonePrefix,
        ctrl.$modelValue,
        attrs.stPhoneExpectedType
      );
    }
  };
};
